const { createElem } = require('./helperFunctions');

export const hideHeaderMenu = (translations) => {
  if (!window.obData || !window.obData.noHeaderMenuStreams) {
    return;
  }

  const streamIDs = window.obData.noHeaderMenuStreams;
  const currentStream = document.querySelector('body').classList[1];

  if (streamIDs.includes(currentStream)) {
    // add class to apply specific CSS (_languageSelector.scss)
    document.querySelector('body').classList.add('header-menu-hidden');

    // header items
    const headerMenu = document.querySelector('#injected-header .main-menu');
    // header local selector, buttons
    const headerRight = document.querySelector('#injected-header .header-right');

    if (headerMenu && headerRight) {
      headerMenu.style.display = 'none';
      headerRight.style.display = 'none';
    }

    const headerLogo = document.querySelector('.site-logo');

    // create homelink

    let newHref = window.location.href;
    const hubID = Hubs.appInstance.ufaCaller.hubId;

    // english hub (no subdirectory vs subdirectory)
    if (hubID === '86270') {
      newHref = newHref.substring(0, 30);
    } else if (hubID === '132028') {
      newHref = window.location.origin;
    } else {
      newHref = newHref.substring(0, 33);
    }

    const homeLILocaleContainer = createElem('div', {
      class: 'home-li-container',
    });

    const homeLI = createElem('li', {
      class: 'home-link-li',
    });

    const homeLink = createElem(
      'a',
      {
        class: 'home-link',
        href: newHref,
      },
      translations.home
    );

    homeLI.append(homeLink);

    homeLILocaleContainer.append(homeLI);

    if (headerLogo) {
      headerLogo.insertAdjacentElement('afterend', homeLILocaleContainer);
    }

    // move hub nav local selector
    const hubNavLocaleSelector = document.querySelector('.locale-selector');

    if (hubNavLocaleSelector) {
      homeLI.insertAdjacentElement('afterend', hubNavLocaleSelector);
    }
  }
};



// WEBPACK FOOTER //
// ./scriptPartials/hideHeaderMenu.js